<div [style.display]="state() === 'inactive' ? 'none' : ''">
  <div class="card mb-2">

    <div style="position:absolute; bottom: 0; right: 5px;">
      <small class="text-gray-400">dewabit Community</small>
    </div>

    <div class="px-3 pt-2 pb-3">
      <div class="d-flex align-items-center">
        <bws-mdi name="comment-text-multiple-outline" class="me-3 fs-1"/>
        <div>
          @if (title()) {
            <small>{{title()}}:</small>
          }
          <small class="d-block" role="alert" aria-live="polite" [attr.aria-label]="message()">
            {{ message() }}
          </small>
        </div>
      </div>
    </div>

  </div>
</div>
